import api from '@/services/utils/apiInstance'

class RentalFileService {
  async createRentalFile(data) {
    const response = await api.post('/distributor/rental-file/create', data)
    return response.data
  }

  async getRentalFileSummary(rentalFileId) {
    const response = await api.get('/distributor/rental-file/summary-detail/' + rentalFileId)
    return response.data
  }

  async getRentalFileSummaryByBoomerangId(rentalFileBoomerangId) {
    const response = await api.get(
      '/distributor/rental-file/summary-detail/by-boomerang-id/' + rentalFileBoomerangId
    )
    return response.data
  }

  async getRentalFileDetail(rentalFileId) {
    const response = await api.get('/distributor/rental-file/detail/' + rentalFileId)
    return response.data
  }

  async getPaginatedRentalFileCommentList(rental_file_id, page, limit, signal = undefined) {
    const url =
      '/distributor/rental-file/comment/list/' +
      rental_file_id +
      '?page=' +
      page +
      '&limit=' +
      limit
    const response = await api.get(url, { signal })
    return response.data
  }

  async createRentalFileComment(data) {
    const response = await api.post('/distributor/rental-file/comment/create', data)
    return response.data
  }

  async getAttachmentFileList(rentalFileId) {
    const response = await api.get('/distributor/rental-file/attachment/list/' + rentalFileId)
    return response.data
  }

  async uploadAttachmentFile(data) {
    const response = await api.put(
      '/distributor/rental-file/attachment/upload-additional-attachment',
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
    return response.data
  }

  async getRentalFileByRepairFileId(repairFileId) {
    const response = await api.get('/distributor/rental-file/by-repair-file/' + repairFileId)
    return response.data
  }

  async getRentalFileDeliveryAddress(rentalFileId) {
    const response = await api.get(
      '/distributor/rental-file/detail/' + rentalFileId + '/delivery-address'
    )
    return response.data
  }

  async getRentalFileDayCountSuppDate(rentalFileId) {
    const response = await api.get(
      '/distributor/rental-file/detail/' + rentalFileId + '/day-supp-count-date'
    )
    return response.data
  }

  async updateRentalFileStatusToClientInformed(rentalFileId, date) {
    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const day = date.getDate().toString().padStart(2, '0')
    let data = {
      rental_file_id: rentalFileId,
      real_date: `${year}-${month}-${day}`
    }

    const response = await api.put('/distributor/rental-file/status-update/client-informed', data)
    return response.data
  }

  async updateRentalFileStatusToStoreReceipt(rentalFileId, date, qrCodeToken, forcePassStatus) {
    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const day = date.getDate().toString().padStart(2, '0')
    let data = {
      rental_file_id: rentalFileId,
      real_date: `${year}-${month}-${day}`,
      qr_code_token: qrCodeToken,
      force_pass_status: forcePassStatus
    }

    const response = await api.put('/distributor/rental-file/status-update/store-receipt', data)
    return response.data
  }

  async getQRCodeToken(rentalFileId) {
    const response = await api.get('/distributor/rental-file/qr-code-token/' + rentalFileId)
    return response.data
  }

  async validateRentalFileQrCodeToken(token) {
    const data = {
      qr_code_token: token
    }
    const response = await api.post('/distributor/rental-file/qr-code-token/validation', data, {
      publicCapability: true
    })

    return response.data
  }

  async sendPictureWithQrCodeToken(data) {
    const response = await api.put('/distributor/rental-file/send-picture-with-qr-code', data, {
      publicCapability: true,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response.data
  }

  async updateRentalFileStatus(rentalFileId, date) {
    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const day = date.getDate().toString().padStart(2, '0')
    let data = {
      rental_file_id: rentalFileId,
      real_date: `${year}-${month}-${day}`
    }

    const response = await api.put('/distributor/rental-file/status-update', data)
    return response.data
  }
}

export default new RentalFileService()
